import React from 'react';
import { FuelFeedback, FuelFlex } from '@frete.com/fuel-station-react';

function EmptyState() {
  return (
    <FuelFlex defaultProps={{ alignItems: 'center', height: '50vh' }}>
      <FuelFeedback
        colorSign="default"
        colorIntensity="strong"
        description="Você pode criar uma nova viagem para monitorar ou revisar os filtros de busca."
        icon="navigation-cursor"
        iconStyle="outlined"
        title="Nenhuma viagem encontrada"
      />
    </FuelFlex>
  );
}

export default EmptyState;
